import React from "react";
import { Link } from "react-router-dom";
import {
  Linkedin, Github, Mail, Phone, FileText, Award, ArrowUpRight,
} from "lucide-react";
import { personal, links } from "../data/mock";

const ICONS = { Linkedin, Github, Mail, Phone, FileText, Award };

const Links = () => {
  return (
    <div>
      <section className="border-b hairline">
        <div className="max-w-[900px] mx-auto px-6 md:px-10 pt-20 md:pt-32 pb-12 text-center">
          <div className="mx-auto w-20 h-20 rounded-full border hairline grid place-items-center font-display text-2xl mb-6">
            HT
          </div>
          <div className="font-mono text-[11px] text-muted-foreground uppercase tracking-widest mb-5">
            06 — Links
          </div>
          <h1 className="display-xl text-4xl md:text-6xl leading-[0.95]">
            Everything, in <span className="italic font-light">one place.</span>
          </h1>
          <p className="mt-6 text-muted-foreground max-w-xl mx-auto leading-relaxed">
            Profiles, inboxes, repos — the quickest way to reach me or see what I’m working on.
          </p>
          <div className="mt-6 inline-flex items-center gap-2 font-mono text-[11px] text-muted-foreground">
            <span className="w-1.5 h-1.5 rounded-full bg-foreground animate-pulse" />
            {personal.status}
          </div>
        </div>
      </section>

      <section className="max-w-[900px] mx-auto px-6 md:px-10 py-12 md:py-20">
        <div className="space-y-3">
          {links.map((l) => {
            const Icon = ICONS[l.icon] || ArrowUpRight;
            return (
              <a
                key={l.label}
                href={l.href}
                target={l.href.startsWith("http") ? "_blank" : undefined}
                rel="noreferrer"
                className="group flex items-center gap-5 p-5 md:p-6 border hairline rounded-md hover:bg-muted/40 transition-colors"
                data-cursor-hover
              >
                <div className="w-11 h-11 rounded-md border hairline grid place-items-center">
                  <Icon size={18} />
                </div>
                <div className="flex-1">
                  <div className="font-display text-lg md:text-xl leading-none">{l.label}</div>
                  <div className="text-xs text-muted-foreground mt-1.5">{l.handle}</div>
                </div>
                <div className="w-10 h-10 rounded-full border hairline grid place-items-center group-hover:bg-foreground group-hover:text-background transition-colors">
                  <ArrowUpRight size={16} />
                </div>
              </a>
            );
          })}
        </div>

        <div className="mt-16 text-center">
          <Link to="/contact" className="btn-primary" data-cursor-hover>
            Or send a direct message <ArrowUpRight size={16} />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Links;
